export const getWizardPropsFromObject = (source) => ({
  fromWizardId: source?.fromWizardId || null,
  fromWizardGroupId: source?.fromWizardGroupId || null,
  fromWizardStep: Number.isInteger(source?.newWizardStep)
    ? source.newWizardStep
    : source?.fromWizardStep,
});

export const hasWizardProps = (wizardProps = {}) => {
  return !!wizardProps.fromWizardGroupId
    && Number.isInteger(wizardProps.fromWizardStep)
    && !!wizardProps.fromWizardId;
};

const parseInteger = (value) => {
  const parsedValue = parseInt(value, 10);
  return Number.isInteger(parsedValue) ? parsedValue : null;
};

export const getWizardPropsFromDataTransfer = (dataTransfer) => ({
  fromWizardId: parseInteger(dataTransfer?.getData('fromWizardId')),
  fromWizardGroupId: dataTransfer?.getData('fromWizardGroupId') || null,
  fromWizardStep: parseInteger(dataTransfer?.getData('fromWizardStep')),
});

export const setWizardPropsToDataTransfer = (dataTransfer, wizardProps) => {
  if (!dataTransfer || !hasWizardProps(wizardProps)) {
    return;
  }

  dataTransfer.setData('fromWizardId', wizardProps.fromWizardId);
  dataTransfer.setData('fromWizardGroupId', wizardProps.fromWizardGroupId);
  dataTransfer.setData('fromWizardStep', wizardProps.fromWizardStep);
};

export const applyWizardPropsToFeature = (feature, wizardProps = {}) => {
  if (!feature || !hasWizardProps(wizardProps)) {
    return feature;
  }

  feature.fromWizardId = wizardProps.fromWizardId;
  feature.fromWizardGroupId = wizardProps.fromWizardGroupId;
  feature.fromWizardStep = wizardProps.fromWizardStep;
  return feature;
};
